module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editReservationPopupBg",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeSubModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "popupArea bg-lightest p-3"
  }, [_c('div', {
    staticClass: "text-center fs-larger font-weight-600 p-3"
  }, [_vm._v("\n            Add Extras\n        ")]), _vm._v(" "), _c('add-extras', {
    staticClass: "extrasHolder",
    attrs: {
      "reservation": _vm.getSelectedReservation
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 my-2"
  }, [_c('div', {
    staticClass: "row w-100 d-flex justify-content-between align-items-end"
  }, [(_vm.loadingPeopleFinancials) ? _c('div', [_c('loader')], 1) : _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_c('label', [_vm._v("Selected seller")]), _vm._v(" "), _c('seller-picker', {
    ref: "sellerSelector",
    staticClass: "w-100",
    attrs: {
      "allowEmpty": false,
      "inlcudeWidget": true,
      "orignalSeller": _vm.selectedSeller
    },
    on: {
      "input": _vm.sellerChanged,
      "deselect": _vm.deselectSeller
    }
  })], 1), _vm._v(" "), (_vm.selectedSellerCommissions) ? _c('div', {
    staticClass: "ml-2"
  }, [_c('label', [_vm._v("Commission")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex bold pt-2"
  }, [_vm._v(_vm._s(_vm.selectedSellerCommissions.commissionComponentValue) + _vm._s(_vm.selectedSellerCommissions.commissionComponentValueType == 1 ? '%' : '€'))])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn primary wider ml-2",
    on: {
      "click": _vm.pressDone
    }
  }, [_vm._v("Done")])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-05a3ff32", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a3ff32"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/AddExtras.vue
// module id = 1698
// module chunks = 0